import clsx from "clsx";

interface SpinnerProps {
  small?: boolean;
  extraSmall?: boolean;
  className?: any;
  loadingText?: string;
  miniSmall?: boolean;
}

export const Spinner = ({
  small,
  extraSmall,
  className,
  loadingText,
  miniSmall,
}: SpinnerProps) => (
  <div className="flex flex-row items-center justify-center gap-1">
    <div
      className={clsx(
        "border border-solid border-t-transparent rounded-[50%] animate-spin-1.5s",
        { ...className },
        {
          "w-[42px] h-[42px] border-4": !small && !extraSmall && !miniSmall,
          "w-[30px] h-[30px] border-[3px]": small,
          "w-[15px] h-[15px] border-2": extraSmall,
          "w-[20px] h-[20px] border-2": miniSmall,
        }
      )}
    ></div>
    {loadingText && <p>{loadingText}</p>}
  </div>
);
